import { cx } from '../../utils';
import type { FC } from 'react';

interface Props {
  className?: string;
  text: React.ReactNode;
}
/**欢迎回到flowUs相关title */
export const Title: FC<Props> = (props) => {
  return (
    <div
      className={cx(
        `flex text-h1 text-center justify-center font-semibold sm:w-full`,
        props.className
      )}
    >
      {props.text}
    </div>
  );
};
